import {type FC} from 'react';
import {Route, Switch} from 'react-router-dom';
import NotFoundPage from '../../containers/NotFoundPage/index.js';
import {PublicLayout} from '../../layouts/index.js';
import {PublicRoutes} from '../../routes/index.js';
import {ROUTES_PREFIX} from '../../utils/constants/shared.js';

const App: FC = () => (
  <Switch>
    <Route path={ROUTES_PREFIX.PUBLIC}>
      <PublicLayout>
        <PublicRoutes />
      </PublicLayout>
    </Route>
    <Route component={NotFoundPage} path='*' />
  </Switch>
);

export default App;
